import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
  providedIn: 'root'
})
export class TranslateLanguageService {

   constructor(private translate: TranslateService) {
    this.translate.addLangs(['en', 'ar']);
    this.translate.setDefaultLang('ar');
    try{
    const savedLang = localStorage.getItem('lang') || 'en';
    this.translate.use(savedLang);
    }catch(e){
      console.error('Error initializing translation service:', e);
    }
  }

  switchLanguage(lang: string) {
    // this.translate.use(lang);
    localStorage.setItem('lang', lang);
    window.location.reload();
  }
  toggleLanguage() {
  const currentLang = this.getCurrentLang();
  const newLang = currentLang === 'en' ? 'ar' : 'en';
  this.switchLanguage(newLang);
  document.documentElement.lang = newLang;
  document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
}

  getCurrentLang() {
    return this.translate?.currentLang || 'en';
  }
}

